<template>
    <div class="editor-container">
        <div class="toolbar-wrapper">
            <Toolbar :editor="editorRef" :defaultConfig="toolbarConfig" :mode="mode" />
        </div>
        <div class="editor-wrapper">
            <Editor :value="modelValue" :defaultConfig="editorConfig" :mode="mode" @onCreated="handleCreated" @onChange="handleChange" />
        </div>
    </div>
</template>

<script>
import '@wangeditor/editor/dist/css/style.css'
import { onBeforeUnmount, shallowRef, watch } from 'vue'
import { ElMessage } from 'element-plus'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import api from '../apis/api'

export default {
    components: { Editor, Toolbar },
    props: {
        modelValue: {
            type: String,
            default: ''
        }
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        const editorRef = shallowRef(null)
        let isSetting = false // 防止初始化时触发onChange

        // 工具栏配置
        const toolbarConfig = {
            excludeKeys: ['blockquote', 'codeBlock', 'header1', 'header2', 'header3', 'todo', 'insertTable', 'insertVideo', 'fullScreen'],
        }

        // 编辑器配置
        const editorConfig = {
            MENU_CONF: {
                uploadImage: {
                    server: api.baseURL() + '/backend/file/upload',
                    fieldName: 'file',
                    maxFileSize: 3 * 1024 * 1024,
                    allowedFileTypes: ['image/*'],
                    headers: api.tokenHeader(),
                    customInsert(res, insertFn) {
                        if (res.code == 'S000001') {
                            let url = res.data.path
                            if (res.data.path && res.data.path.indexOf('http') != 0) {
                                url = window.location.origin + res.data.path
                            }
                            insertFn(url)
                        } else {
                            ElMessage.error(res.message || '上传失败')
                        }
                    }
                }
            }
        }

        // 编辑器创建回调
        const handleCreated = (editor) => {
            editorRef.value = editor

            // 设置初始值
            if (props.modelValue) {
                isSetting = true
                editor.setHtml(props.modelValue)
                isSetting = false
            }
        }

        // 内容变化回调
        const handleChange = (editor) => {
            if (isSetting) return // 跳过初始化设置时的触发
            const html = editor.getHtml()
            emit('update:modelValue', html)
        }

        // 监听父组件值变化
        watch(() => props.modelValue, (newVal) => {
            if (!editorRef.value || editorRef.value.isEmpty()) return
            if (newVal === editorRef.value.getHtml()) return

            isSetting = true
            editorRef.value.setHtml(newVal)
            isSetting = false
        })

        // 组件销毁处理
        onBeforeUnmount(() => {
            const editor = editorRef.value
            if (editor) {
                editor.destroy()
                editorRef.value = null
            }
        })

        return {
            editorRef,
            mode: 'simple',
            toolbarConfig,
            editorConfig,
            handleCreated,
            handleChange
        }
    }
}
</script>

<style scoped>
.editor-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    border: 1px solid #ccc;
}

.toolbar-wrapper {
    flex-shrink: 0;
    border-bottom: 1px solid #ccc;
}

.editor-wrapper {
    flex: 1;
    min-height: 300px;
    overflow: hidden;
    position: relative;
}

::v-deep .w-e-text-container {
    height: 100% !important;
}

::v-deep .w-e-scroll {
    height: calc(100% - 35px) !important;
}
</style>